import Rssfeed from './rssfeed';

export default class WeatherAlert extends Rssfeed {
  constructor(el) {
    super(el);
    this.getdata().then((res) => {
      this.appendDetails();
    });
  }

  appendDetails() {
    console.log(this.data.rss.channel.item);
    if (!this.data.rss.channel.item) {
      this.el.insertAdjacentHTML('beforeend', `<li>No weather alerts</li>`);
      this.el.style.display = 'initial';
    } else {
      this.appenddata({ description: true });
    }
  }
}
